import { combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import {
    BoundarySlice,
    NavSlice,
    HeaderSlice,
    HseDiarySlice,
    HseIncidentSlice,
    MagnetismSlice,
    WasteSlice,
    ConsumableSlice,
    MMOSlice,
    DrillSlice,
    ROVSlice,
    USVSlice,
    RWPSlice,
    SourceSlice,
    WeatherSlice,
    WorkboatSlice,
    HelicopterSlice,
    ActivityDiarySlice,
    FleetSummarySlice,
    FocusAcquisitionSlice,
    AcquisitionSlice,
    ReceiveSlice,
    CompensationSlice,
    ProjectConfigSlice,
    ModalFormItemSlice,
    LocationSlice,
    PreplotSlice,
    TerrainPreplotSlice,
    CurrentDateSlice,
    EncryptionSlice,
    HomeSlice,
    AppSlice,
    LogSettingSlice,
    MapSlice,
    ReceiveLandSlice,
    HealthSlice,
    ClearanceSlice,
    LineClearanceSlice,
    NearSurfaceInspectionSlice,
    NonSeismicSlice,
    OnSiteProcessingSlice,
    PermitSlice,
    LoadingSlice,
    MaterialsSlice,
    VehicleSlice,
    PlanSlice,
    MeasurementSlice
} from './reducers'

// 持久化存储白名单，https://github.com/rt2zz/redux-persist#nested-persists
const MapSlicePersistConfig = {
    key: 'MapSlice',
    storage,
    whitelist: ['rangePicker', 'layerList', 'renderLayers'],
}

const NavSlicePersistConfig = {
    key: 'NavSlice',
    storage,
    whitelist: ['openKeys', 'selectedKeys', 'identityID'],
}

const HseDiarySlicePersistConfig = {
    key: 'HseDiarySlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const HealthSlicePersistConfig = {
    key: 'HealthSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const HseIncidentSlicePersistConfig = {
    key: 'HseIncidentSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const MagnetismSlicePersistConfig = {
    key: 'MagnetismSlice',
    storage,
    whitelist: ['locationName', 'locationId'],
}
const WasteSlicePersistConfig = {
    key: 'WasteSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const ConsumableSlicePersistConfig = {
    key: 'ConsumableSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const MMOSlicePersistConfig = {
    key: 'MMOSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const ClearanceSlicePersistConfig = {
    key: 'ClearanceSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const MeasurementSlicePersistConfig = {
    key: 'MeasurementSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const LineClearanceSlicePersistConfig = {
    key: 'LineClearanceSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const NearSurfaceInspectionSlicePersistConfig = {
    key: 'NearSurfaceInspectionSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const NonSeismicSlicePersistConfig = {
    key: 'NonSeismicSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const OnSiteProcessingSlicePersistConfig = {
    key: 'OnSiteProcessingSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const PermitSlicePersistConfig = {
    key: 'PermitSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const LoadingSlicePersistConfig = {
    key: 'LoadingSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const MaterialsSlicePersistConfig = {
    key: 'MaterialsSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const VehicleSlicePersistConfig = {
    key: 'VehicleSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const DrillSlicePersistConfig = {
    key: 'DrillSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const ROVSlicePersistConfig = {
    key: 'ROVSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const USVSlicePersistConfig = {
    key: 'USVSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const RWPSlicePersistConfig = {
    key: 'RWPSlice',
    storage,
    whitelist: ['pageNum', 'locationName', 'locationId'],
}
const SOURCESlicePersistConfig = {
    key: 'SourceSlice',
    storage,
    whitelist: ['pageNum', 'locationName', 'locationId'],
}
const WeatherSlicePersistConfig = {
    key: 'WeatherSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const WorkboatSlicePersistConfig = {
    key: 'WorkboatSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const HelicopterSlicePersistConfig = {
    key: 'HelicopterSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const ActivityDiarySlicePersistConfig = {
    key: 'ActivityDiarySlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const FleetSummarySlicePersistConfig = {
    key: 'FleetSummarySlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const FocusAcquisitionSlicePersistConfig = {
    key: 'FocusAcquisitionSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const AcquisitionSlicePersistConfig = {
    key: 'AcquisitionSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const ReceiveSlicePersistConfig = {
    key: 'ReceiveSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const ReceiveLandSlicePersistConfig = {
    key: 'ReceiveLandSlice',
    storage,
    whitelist: ['calendarInfo', 'locationName', 'locationId'],
}
const HomeSlicePersistConfig = {
    key: 'HomeSlice',
    storage,
    whitelist: ['pageNum'],
}
const LocationSlicePersistConfig = {
    key: 'LocationSlice',
    storage,
    whitelist: ['pageNum', 'locationName', 'locationId', 'locationType', 'callSign'],
}
const PreplotSlicePersistConfig = {
    key: 'PreplotSlice',
    storage,
    whitelist: ['pageNum'],
}
const TerrainPreplotSlicePersistConfig = {
    key: 'TerrainPreplotSlice',
    storage,
    whitelist: ['pageNum'],
}
const LogSettingSlicePersistConfig = {
    key: 'LogSettingSlice',
    storage,
    whitelist: ['FocusItemKey', 'FocusItemKeyDict', 'TabsActiveKey'],
}
const AppSlicePersistConfig = {
    key: 'AppSlice',
    storage,
    whitelist: ['authLocationData'],
}
const HeaderSlicePersistConfig = {
    key: 'HeaderSlice',
    storage,
    whitelist: ['outlineBorder'],
}

// 合并 reudcer
export default combineReducers({
    BoundarySlice: BoundarySlice.reducer,
    HealthSlice: persistReducer(HealthSlicePersistConfig, HealthSlice.reducer),
    NavSlice: persistReducer(NavSlicePersistConfig, NavSlice.reducer),
    HeaderSlice: persistReducer(HeaderSlicePersistConfig, HeaderSlice.reducer),
    HseDiarySlice: persistReducer(HseDiarySlicePersistConfig, HseDiarySlice.reducer),
    HseIncidentSlice: persistReducer(HseIncidentSlicePersistConfig, HseIncidentSlice.reducer),
    MagnetismSlice: persistReducer(MagnetismSlicePersistConfig, MagnetismSlice.reducer),
    WasteSlice: persistReducer(WasteSlicePersistConfig, WasteSlice.reducer),
    ConsumableSlice: persistReducer(ConsumableSlicePersistConfig, ConsumableSlice.reducer),
    MMOSlice: persistReducer(MMOSlicePersistConfig, MMOSlice.reducer),
    ClearanceSlice: persistReducer(ClearanceSlicePersistConfig, ClearanceSlice.reducer),
    MeasurementSlice: persistReducer(MeasurementSlicePersistConfig, MeasurementSlice.reducer),
    LineClearanceSlice: persistReducer(LineClearanceSlicePersistConfig, LineClearanceSlice.reducer),
    NearSurfaceInspectionSlice: persistReducer(NearSurfaceInspectionSlicePersistConfig, NearSurfaceInspectionSlice.reducer),
    NonSeismicSlice: persistReducer(NonSeismicSlicePersistConfig, NonSeismicSlice.reducer),
    OnSiteProcessingSlice: persistReducer(OnSiteProcessingSlicePersistConfig, OnSiteProcessingSlice.reducer),
    PermitSlice: persistReducer(PermitSlicePersistConfig, PermitSlice.reducer),
    LoadingSlice: persistReducer(LoadingSlicePersistConfig, LoadingSlice.reducer),
    MaterialsSlice: persistReducer(MaterialsSlicePersistConfig, MaterialsSlice.reducer),
    VehicleSlice: persistReducer(VehicleSlicePersistConfig, VehicleSlice.reducer),
    DrillSlice: persistReducer(DrillSlicePersistConfig, DrillSlice.reducer),
    ROVSlice: persistReducer(ROVSlicePersistConfig, ROVSlice.reducer),
    USVSlice: persistReducer(USVSlicePersistConfig, USVSlice.reducer),
    RWPSlice: persistReducer(RWPSlicePersistConfig, RWPSlice.reducer),
    SourceSlice: persistReducer(SOURCESlicePersistConfig, SourceSlice.reducer),
    WeatherSlice: persistReducer(WeatherSlicePersistConfig, WeatherSlice.reducer),
    WorkboatSlice: persistReducer(WorkboatSlicePersistConfig, WorkboatSlice.reducer),
    HelicopterSlice: persistReducer(HelicopterSlicePersistConfig, HelicopterSlice.reducer),
    ActivityDiarySlice: persistReducer(ActivityDiarySlicePersistConfig, ActivityDiarySlice.reducer),
    FleetSummarySlice: persistReducer(FleetSummarySlicePersistConfig, FleetSummarySlice.reducer),
    FocusAcquisitionSlice: persistReducer(FocusAcquisitionSlicePersistConfig, FocusAcquisitionSlice.reducer),
    AcquisitionSlice: persistReducer(AcquisitionSlicePersistConfig, AcquisitionSlice.reducer),
    ReceiveSlice: persistReducer(ReceiveSlicePersistConfig, ReceiveSlice.reducer),
    ReceiveLandSlice: persistReducer(ReceiveLandSlicePersistConfig, ReceiveLandSlice.reducer),
    CompensationSlice: CompensationSlice.reducer,
    ProjectConfigSlice: ProjectConfigSlice.reducer,
    ModalFormItemSlice: ModalFormItemSlice.reducer,
    PlanSlice: PlanSlice.reducer,
    LocationSlice: persistReducer(LocationSlicePersistConfig, LocationSlice.reducer),
    PreplotSlice: persistReducer(PreplotSlicePersistConfig, PreplotSlice.reducer),
    TerrainPreplotSlice: persistReducer(TerrainPreplotSlicePersistConfig, TerrainPreplotSlice.reducer),
    CurrentDateSlice: CurrentDateSlice.reducer,
    EncryptionSlice: EncryptionSlice.reducer,
    HomeSlice: persistReducer(HomeSlicePersistConfig, HomeSlice.reducer),
    AppSlice: persistReducer(AppSlicePersistConfig, AppSlice.reducer),
    LogSettingSlice: persistReducer(LogSettingSlicePersistConfig, LogSettingSlice.reducer),
    MapSlice: persistReducer(MapSlicePersistConfig, MapSlice.reducer),
})
